module.exports = __webpack_public_path__ + "static/media/icon-file-upload.81061684.svg";